import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Divider,
  Avatar,
  Button,
  Chip,
  Paper,
  Dialog,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { VendorProfile as VendorProfileAction } from "../../../Redux/action/VendorProfileAction";
import Loader from "../../Common/Loader/loader";
import { IoEyeOutline } from "react-icons/io5";
import CloseIcon from "@mui/icons-material/Close";

const ViewProfile = ({ handleChange }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state?.VendorProfile?.result);
  console.log("userInfo", userInfo);
  const { userResult } = useSelector((state) => state.Auth);
  const id = userResult?.vendorid;

  const [state, setState] = useState({});
  const [locations, setLocations] = useState([]);
  const [dialogPreview, setDialogPreview] = useState(null);

  const isIndian = userInfo?.countryCode === "in";

  const getPreviewType = (url) => {
    if (!url) return "unknown";
    const ext = url.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "webp"].includes(ext)) return "image";
    if (ext === "pdf") return "pdf";
    return "unknown";
  };

  useEffect(() => {
    if (userInfo?.vendorId) {
      setState({
        vendorId: userInfo?.vendorId,
        firstName: userInfo?.firstName,
        lastName: userInfo?.lastName,
        vendorEmailId: userInfo?.email,
        mobile: userInfo?.mobile,
        companyWebsite: userInfo?.companyWebsite,
        vendorEmpId: userInfo?.vendorEmpId,
        city: userInfo?.city,
        country: userInfo?.country,
        dialCode: userInfo?.dialCode,
        address: userInfo?.address,
        description: userInfo?.description,
        company: userInfo?.company,
        gstNumber: userInfo?.gstNumber,
        panNumber: userInfo?.panNumber,
        governmentId: userInfo?.governmentId,
        governmentTaxId: userInfo?.governmentTaxId,
      });
    }
    setLocations(userInfo?.locations || []);
  }, [userInfo]);

  useEffect(() => {
    dispatch(VendorProfileAction(id));
  }, [dispatch, id]);

  if (!state?.vendorId) {
    return (
      <div
        style={{
          height: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Grid
        container
        spacing={3}
        sx={{ p: 2, margin: "auto" }}
        className="ven_dash_wrapper"
      >
        {/* Profile Details */}
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardHeader
              title="Profile Details"
              style={{ color: "#286a94" }}
              action={
                <Button
                  variant="contained"
                  onClick={handleChange}
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: 600,
                    backgroundColor: "#286a94",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#1e5474",
                    },
                  }}
                >
                  Edit Profile
                </Button>
              }
            />
            <Divider />
            <CardContent>
              <Grid container spacing={3}>
                {/* Profile Picture moved here */}
                <Grid
                  item
                  xs={12}
                  md={3}
                  sx={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    src={userInfo?.vendorProfileImageUrl}
                    sx={{ width: 140, height: 140 }}
                  />
                  <Typography variant="h6" mt={2}>
                    {state.firstName} {state.lastName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {state.vendorEmpId || "Not Provided"}
                  </Typography>
                </Grid>

                {/* Profile Info Fields */}
                <Grid item xs={12} md={9}>
                  <Grid container spacing={2}>
                    {[
                      { label: "First Name", value: state.firstName },
                      { label: "Last Name", value: state.lastName },
                      { label: "Email", value: state.vendorEmailId },
                      { label: "Mobile", value: state.mobile },
                    ].map((field, index) => (
                      <Grid item xs={12} md={6} key={index}>
                        <Typography variant="subtitle2">
                          {field.label}
                        </Typography>
                        <Paper
                          sx={{ p: 1.5, borderRadius: 2, mt: 0.5 }}
                          variant="outlined"
                        >
                          {field.value || "N/A"}
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Company Details */}
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardHeader title="Company Details" style={{ color: "#286a94" }} />
            <Divider />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2">Company Website</Typography>
                  <Paper sx={{ p: 1.5 }} variant="outlined">
                    {state.companyWebsite || "N/A"}
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2">Company Name</Typography>
                  <Paper sx={{ p: 1.5 }} variant="outlined">
                    {state.company || "N/A"}
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2">Company Logo</Typography>
                  <div style={{ marginTop: 10 }}>
                    {userInfo?.companyLogoUrl ? (
                      <img
                        src={userInfo?.companyLogoUrl}
                        alt="Company Logo"
                        style={{
                          width: 150,
                          height: 150,
                          objectFit: "contain",
                          border: "1px solid #ccc",
                          borderRadius: 8,
                          padding: 10,
                        }}
                      />
                    ) : (
                      <Chip label="No Logo Uploaded" color="warning" />
                    )}
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2">Description</Typography>
                  <Paper sx={{ p: 2 }} variant="outlined">
                    {state.description || "No description added"}
                  </Paper>
                </Grid>
              </Grid>

              {/* Locations */}
              {locations?.sort((a, b) => (a.locationType === "HEADQUARTERS" ? -1 : 1))?.map((loc, i) => (
                <Paper key={i} sx={{ p: 2, mt: 3 }} variant="outlined">
                  <Typography
                    variant="subtitle2"
                    style={{ color: "#286a94" }}
                    sx={{ textTransform: "uppercase", fontWeight: "bold" }}
                  >
                    {loc.locationType}
                  </Typography>
                  <Divider sx={{ my: 1 }} />

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2">Address</Typography>
                      <Paper sx={{ p: 1.5 }} variant="outlined">
                        {loc.address}
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2">Country</Typography>
                      <Paper sx={{ p: 1.5 }} variant="outlined">
                        {loc.country}
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2">State</Typography>
                      <Paper sx={{ p: 1.5 }} variant="outlined">
                        {loc.state || "N/A"}
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle2">City</Typography>
                      <Paper sx={{ p: 1.5 }} variant="outlined">
                        {loc.city}
                      </Paper>
                    </Grid>
                  </Grid>
                </Paper>
              ))}
            </CardContent>
          </Card>
        </Grid>

        {/* Documents */}
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardHeader title="Documents" style={{ color: "#286a94" }} />
            <Divider />
            <CardContent>
              <Grid container spacing={2}>
                {[
                  {
                    label: isIndian ? "PAN Number" : "Government Tax ID",
                    value: state.panNumber || state.governmentTaxId,
                    doc: userInfo?.panImageUrl,
                  },
                  {
                    label: "GST Number",
                    value: state.gstNumber,
                    doc: userInfo?.gstImageUrl,
                  },
                  {
                    label: "MSA Document",
                    value: "Uploaded",
                    doc: userInfo?.msadocUrl,
                  },
                  {
                    label: "NDA Document",
                    value: "Uploaded",
                    doc: userInfo?.ndadocUrl,
                  },
                ].map((item, i) => (
                  <Grid item xs={12} md={6} key={i}>
                    <Typography variant="subtitle2">{item.label}</Typography>
                    <Paper sx={{ p: 1.5 }} variant="outlined">
                      {item.value || "N/A"}
                      {item.doc && (
                        <IconButton
                          size="small"
                          sx={{ float: "right" }}
                          onClick={() => setDialogPreview(item.doc)}
                        >
                          <IoEyeOutline size={20} />
                        </IconButton>
                      )}
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Preview Modal */}
      <Dialog
        open={!!dialogPreview}
        onClose={() => setDialogPreview(null)}
        maxWidth="lg"
        fullWidth
      >
        <IconButton
          sx={{ position: "absolute", color: "red", right: 5, top: 10 }}
          onClick={() => setDialogPreview(null)}
        >
          <CloseIcon />
        </IconButton>

        {dialogPreview && getPreviewType(dialogPreview) === "image" && (
          <img
            src={dialogPreview}
            alt="Preview"
            style={{ width: "100%", padding: 20 }}
          />
        )}

        {dialogPreview && getPreviewType(dialogPreview) === "pdf" && (
          <iframe
            src={dialogPreview}
            title="PDF Preview"
            style={{ width: "100%", height: "80vh", border: "none" }}
          />
        )}

        {dialogPreview && getPreviewType(dialogPreview) === "unknown" && (
          <Typography sx={{ p: 4, textAlign: "center" }}>
            Preview not supported.{" "}
            <a href={dialogPreview} download>
              Download file
            </a>
          </Typography>
        )}
      </Dialog>
    </>
  );
};

export default ViewProfile;
